/* eslint-disable */
import {
  Table,
  Th,
  Td,
  SimpleSearchInput,
  Pagination,
  ImportExcel,
} from "@app/components";
import Button from "@app/components/Button";
import { useGetPatientVisit } from "@app/services/omr-service";
import { formatNumber } from "@app/utils";
import { Link, useRouteMatch } from "react-router-dom";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  DocumentAddIcon,
  PlusIcon,
  PlusSmIcon,
  SearchIcon,
} from "@heroicons/react/outline";
import ReactSelect from "@app/components/ReactSelect.js";
import InputDate from "@app/components/InputDate";
import { useState } from "react";
import Label from "@app/components/Label";
import Input from "@app/components/Input";

export const News = () => {
  let dataStatus = [
    { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
    { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
    { value: "purple", label: "Purple", color: "#5243AA" },
    { value: "red", label: "Red", color: "#FF5630", isFixed: true },
    { value: "orange", label: "Orange", color: "#FF8B00" },
    { value: "yellow", label: "Yellow", color: "#FFC400" },
    { value: "green", label: "Green", color: "#36B37E" },
    { value: "forest", label: "Forest", color: "#00875A" },
    { value: "slate", label: "Slate", color: "#253858" },
    { value: "silver", label: "Silver", color: "#666666" },
  ];
  const { data, isFetching, isLoading, payload, setPayload, refetch } =
    useGetPatientVisit({ patient_type: "out-patient" });
  const [selectedDay, setSelectedDay] = useState(null);
  let rows = []; //
  let row = (
    <>
      <tr>
        <td className="px-6 py-4 whitespace-nowrap">
          <div className="flex items-center">
            <div className="flex-shrink-0 h-10 w-10">
              <img
                className="h-10 w-10 rounded-full"
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60"
                alt=""
              />
            </div>
            <div className="ml-4">
              <div className="text-sm font-medium text-gray-900">
                Jane Cooper
              </div>
              <div className="text-sm text-gray-500">
                jane.cooper@example.com
              </div>
            </div>
          </div>
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
          <div className="text-sm text-gray-900">
            Regional Paradigm Technician
          </div>
          <div className="text-sm text-gray-500">Optimization</div>
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
            Active
          </span>
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
          Admin
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
          <Link
            to="/news/edit"
            className="text-indigo-600 hover:text-indigo-900"
          >
            Edits
          </Link>
        </td>
      </tr>
      <tr>
        <td className="px-6 py-4 whitespace-nowrap">
          <div className="flex items-center">
            <div className="flex-shrink-0 h-10 w-10">
              <img
                className="h-10 w-10 rounded-full"
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60"
                alt=""
              />
            </div>
            <div className="ml-4">
              <div className="text-sm font-medium text-gray-900">
                Jane Cooper
              </div>
              <div className="text-sm text-gray-500">
                jane.cooper@example.com
              </div>
            </div>
          </div>
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
          <div className="text-sm text-gray-900">
            Regional Paradigm Technician
          </div>
          <div className="text-sm text-gray-500">Optimization</div>
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
            Active
          </span>
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
          Admin
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
          <a href="#" className="text-indigo-600 hover:text-indigo-900">
            Edit
          </a>
        </td>
      </tr>
    </>
  );
  for (var i = 0; i < 10; i++) {
    rows.push(row);
  }
  return (
    <div>
      <div className="flex flex-row">
        <h1 className="flex-grow text-2xl">Informasi Terbaru</h1>

        <Link to="/news/add">
          <Button
            variant="solid"
            color="blue"
            leftIcon={<PlusSmIcon className="bg-blue-300 rounded" />}
          >
            <div className="px-2 text-white">Tambah Baru</div>
          </Button>
        </Link>
      </div>
      <div className="grid grid-cols-3 mt-6 gap-4 ">
        <div className="w-full  ">
          <Label size="sm" font="bold">
            Judul
          </Label>
          <Input placeholder="Masukkan Judul" />
        </div>

        <div className="w-full  ">
          <Label size="sm" font="bold">
            Kategori
          </Label>
          <div className="mt-1">
            {/* <select
              name="price"
              id="price"
              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-2 py-2 sm:text-sm border-gray-300 rounded-md"
            /> */}
            <ReactSelect placeholder="Pilih Kategori" options={dataStatus} />
          </div>
        </div>

        <div className="w-full  ">
          <Label size="sm" font="bold">
            Tag
          </Label>
          <Input placeholder="Masukkan Tag" />
        </div>

        <div className="w-full  ">
          <Label size="sm" font="bold">
            Status
          </Label>
          <div className="mt-1">
            {/* <select
              name="price"
              id="price"
              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-2 py-2 sm:text-sm border-gray-300 rounded-md"
            /> */}
            <ReactSelect placeholder="Pilih Kategori" options={dataStatus} />
          </div>
        </div>
        <div className="flex flex-row content-center">
          <Button
            leftIcon={<SearchIcon />}
            variant="solid"
            className="bg-green-400 rounded px-8 py-3.5 text-white text-sm mt-4"
          >
            Cari
          </Button>{" "}
        </div>
      </div>

      {/* //! Table */}
      <div className="flex flex-col mt-6">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Title
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Role
                    </th>
                    <th scope="col" className="relative px-6 py-3">
                      <span className="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {rows}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
``;
